import { IBlog, reynaldoSocialNetwork } from "./data"
import DS from "../../assets/ds.png";


interface DSBlogs {
    data: IBlog[]
}

export const DSTRUCTURE: DSBlogs = {
    data: [
        {
            ID: 1,
            Title: "Data Structure",
            Image: DS,
            Author: "Reynaldo Mejia",
            SocialLink: reynaldoSocialNetwork[0].Link,
            SocialNetwork: reynaldoSocialNetwork,
            Content: [
                {
                    Title: "What are Data Strutures",
                    Text: "A data structure is a way to organize, store, add, remove, and access data efficiently." +
                        " Example, Imagine you want to organize your favorite books in order. One way to do this is by" +
                        " author name, and another is by genre."
                },
                {
                    Title: "Algorithm",
                    Text: "An algorithm is a set of instructions or a step-by-step process to solve" +
                        " a problem or complete a task. A common example of an algorithm is following a recipe."
                },
                {
                    Title: "Key Points"
                },
                {
                    Text: "• Organization: Defines how data is organized and connected for efficient storage and retrieval."
                },
                {
                    Text: "• Management: covers operations like adding, removing, searching and updating  data."
                },
                {
                    Text: "• Efficiency: Aims to optimize operations by minimizing the time and resources required to perform a task."
                },
                {
                    Title: "Conclusion",
                    Text: "Understanding data structures and algorithms is essential for writing efficient and effective code." +
                        " Data structures help organize and manage data, while algorithms provide clear steps to solve problems." +
                        " Together, they form the foundation for building reliable and optimized software."
                }
            ]
        },
        {
            ID: 2,
            Title: "Array",
            Image: DS,
            Author: "Reynaldo Mejia",
            SocialLink: reynaldoSocialNetwork[0].Link,
            SocialNetwork: reynaldoSocialNetwork,
            Content: [
                {
                    Title: "Array",
                    Text: "An Array is a collection of elements of the same type." +
                        " Each item in this collection can be accessed using its portions index."
                },
                {
                    Title: "Defining an Array",
                },
                {
                    Text: "TypeScript",
                    Sample: `let myArray: number [] = [1, 2, 3];

You can also use generics 
let myNameList: Array<string> = [“Sofia”,“Robert”];`
                },
                {
                    Text: "Java",
                    Sample: `// Declaring and initializing an array of integers
int[] numbers = {1, 2, 3, 4, 5};
System.out.println("Java Integer Array: " + java.util.Arrays.toString(numbers));

// Declaring an array and then allocating memory and initializing elements
String[] fruits = new String[3];
fruits[0] = "Apple";
fruits[1] = "Banana";
fruits[2] = "Cherry";
System.out.println("Java String Array: " + java.util.Arrays.toString(fruits));

// Creating an array of a custom object
class Car {
    String model;
    Car(String model) {
        this.model = model;
    }
    @Override
    public String toString() {
        return model;
    }
}

Car[] cars = new Car[2];
cars[0] = new Car("Toyota");
cars[1] = new Car("Honda");
System.out.println("Java Car Array: " + java.util.Arrays.toString(cars));`
                },
                {
                    Text: "Kotlin",
                    Sample: `// Declaring and initializing an array of integers
val numbers = arrayOf(1, 2, 3, 4, 5)
println(number[0]) // access index 0 element 1
println("Kotlin Integer Array: \${numbers.contentToString()}")

// Declaring an array of a specific type
val names: Array<String> = arrayOf("Alice", "Bob", "Charlie")
println("Kotlin String Array: \${names.contentToString()}")

// Creating an array of a specific size with all elements initialized to null (for nullable types)
val nullableArray: Array<String?> = arrayOfNulls(3)
nullableArray[0] = "Kotlin"
println("Kotlin Nullable String Array: \${nullableArray.contentToString()}")

// Creating an array using the Array constructor with a lambda for initialization
val evenNumbers = Array(5) { i -> (i + 1) * 2 }
println("Kotlin Even Numbers Array: \${evenNumbers.contentToString()}")

// Array of custom objects
data class Book(val title: String, val author: String)

val books = arrayOf(
    Book("The Hitchhiker's Guide to the Galaxy", "Douglas Adams"),
    Book("1984", "George Orwell")
)
println("Kotlin Book Array: \${books.contentToString()}")`
                },
                {
                    Text: "Go",
                    Sample: ` // Declaring and initializing an array of integers
    var numbers = [5]int{1, 2, 3, 4, 5}
    fmt.Println("Go Integer Array:", numbers)

    // Declaring an array and then assigning values
    var fruits [3]string
    fruits[0] = "Apple"
    fruits[1] = "Banana"
    fruits[2] = "Cherry"
    fmt.Println("Go String Array:", fruits)

    // Short declaration for an array, size is inferred
    names := [...]string{"Alice", "Bob", "Charlie"}
    fmt.Println("Go Inferred Size String Array:", names)

    // Creating an array of a custom struct
    type Car struct {
        Model string
        Year  int
    }

    var cars = [2]Car{
        {"Toyota", 2020},
        {"Honda", 2022},
    }
    fmt.Println("Go Car Array:", cars)`
                },
                {
                    Title: "Methods",
                },
                {
                    Text: "• Push: Adds new element to the array."
                },
                {
                    Text: "• Pop: Removes last element of the array."
                },
                {
                    Text: "• Sort: Sorts all element of the array."
                },
                {
                    Title: "Conclusion",
                    Text: "Arrays offer a simple and efficient way to store and access multiple values using indices." +
                        " Whether you're working with numbers, strings, or custom objects, arrays are a fundamental" +
                        " building block in any programming language."
                }
            ]
        },
        {
            ID: 3,
            Title: "Linked List",
            Image: DS,
            Author: "Reynaldo Mejia",
            SocialLink: reynaldoSocialNetwork[0].Link,
            SocialNetwork: reynaldoSocialNetwork,
            Content: [
                {
                    Title: "Linked List",
                    Text: "A Linked List is a linear data structure used for storing a collection of elements." +
                        " Imagine a linked list as a chain where each element is connected. Unlike arrays," +
                        " Linked Lists use nodes to store data." +
                        " A node in a Linked List is a block that holds the data and points to the next node."
                },
                {
                    Title: "Head And Tail",
                    Text: "The first element in a Linked List is called the head and is" +
                        " the starting point. The head points to the next node in the linked" +
                        " list. The tail is the last element in the linked list and points to a null value."
                },
                {
                    Title: "Linked List Methods"
                },
                { Text: "• add(item): Adds a new element to the beginning or end of the list." },
                { Text: "• remove(): Removes an element from the beginning or end of the list." },
                { Text: "• size(): Returns the length of the list." },
                {
                    Title: "Node Class",
                    Text: "A node class is a single node in the Linked List, holding data and reference" +
                        " to next node. The item is the data value store in the node for this example the data" +
                        " type is number. The next property is a pointer to next node int list, or null if" +
                        " the node is the last element. In the constructor initialize a new Node with the item value and set next to null."
                },
                {
                    Title: "TypeScript",
                    Sample: `export class Node {
    item: number;
    next: Node | null;

    constructor(item: number) {
        this.item = item;
        this.next = null;
    }
}`
                },
                {
                    Title: "Java",
                    Sample: `public class Node {
    int item;
    Node next; // No 'null' type here, it's implicitly nullable

    public Node(int item) {
        this.item = item;
        this.next = null;
    }
}`
                },
                {
                    Title: "Kotlin",
                    Sample: `class Node(val item: Int) {
    var next: Node? = null // '?' denotes nullable type, '= null' for initialization
}`
                },
                {
                    Title: "Go",
                    Sample: `type Node struct {
    Item int
    Next *Node // Pointers are used for linked structures, *Node means a pointer to a Node
}

func NewNode(item int) *Node {
    return &Node{Item: item, Next: nil} // nil is the equivalent of null
}`
                },
                {
                    Title: "Linked List Class and Methods",
                    Text: "The Linked List class manage the collection of nodes. The head property is a pointer to the first element" +
                        " in the list, or null if is empty. The tail property is a pointer to the last element in the list." +
                        " The len property is number of nodes in the list. The constructor initialize the values head and tail to null and len to 0."
                },
                {
                    Title: "Delete",
                    Text: "Delete method, Removing the first node(head) from linked list. First check if list is empty" +
                        " ( head is not null ), we point the head to the next node in the list."
                },
                {
                    Title: "Size",
                    Text: "The size method return the current number of nodes in the linked list. This method simply return the value of len property."
                },
                {
                    Title: "Traverse",
                    Text: "Traversing or print. First create a current node variable initialize to the head of the list." +
                        " We loop, While current is not null than we print value of current node value (item), move current to the next node using current.next."
                },
                {
                    Title: "Linked List Code Example",
                    Text: "This TypeScript code example can be adapted and modified for use with Java, Kotlin, Go, or your chosen programming language.",
                    Sample: `export class LinkedList {

    head: Node | null;
    tail: Node | null;
    len: number;

    constructor() {
        this.head = null;
        this.tail = null;
        this.len = 0;
    }

    // append
    public append(item: number): void {
        const newNode = new Node(item);

        if (this.head == null) {
            this.head = newNode;
            this.tail = newNode;
        }else {
            this.tail!.next = newNode;
            this.tail = newNode;
        }
        this.len++

    }

    // delete
    public delete(): void {
        if (this.head != null) {
            this.head = this.head.next;
            this.len--;
            return;
        }
    }

    // size
    public size(): number {
        return this.len;
    }

    // traverse
    public print(): void {
        let current: Node | null = this.head;

        while (current != null) {
            console.log(current.item);
            current = current.next;
        }

    }
}`
                },
                {
                    Title: "Conclusion",
                    Text: "Linked Lists are flexible data structures that store elements in connected nodes," +
                        " allowing efficient insertion and removal without resizing. Unlike arrays," +
                        " they grow dynamically and are ideal for scenarios where frequent data changes" +
                        " occur. Understanding how nodes, head, tail, and traversal work is key to using linked lists effectively."
                }

            ]
        },
        {
            ID: 4,
            Title: "Stack",
            Image: DS,
            Author: "Reynaldo Mejia",
            SocialLink: reynaldoSocialNetwork[0].Link,
            SocialNetwork: reynaldoSocialNetwork,
            Content: [
                {
                    Title: "Stack",
                    Text: `Stack is a linear data structure that follows the principle of LIFO (Last In, First Out).
                     This means that the last element inserted in the stack is the first element removed.
                     Stacks can be implemented using arrays or linked lists.`
                },
                {
                    Title: "Stack Operations Method",
                },
                { Text: "• Push: Add new element to top." },
                { Text: "• Pop: Removes an element from the top of the stack." },
                { Text: "• IsEmpty: Returns true or false if the stack is empty." },
                { Text: "• Peek: Get the last entry (top) from the stack." },
                { Text: "• Print: This method displays all elements in the stack array." },
                {
                    Title:"Array Implementation"
                },
                {
                    Text:`We have created a new class named Stack with three private properties: data, top, and size.
                     Additionally, we introduced STACK_EMPTY which is a readonly property and the initial of our stack.`
                },
                {
                    Text:`In the constructor, which takes a size parameter, we assign values to the data, top, and size properties.`
                },
                {
                    Text:`The push method checks if the stack is full before adding a new element to the top.
                     If the stack is full, the operation is aborted; otherwise, we increment the top by one and insert the new element.`
                },
                {
                    Text:`The isFull method is private and only used within the class.
                     It checks if the size is equal to the top and returns true or false accordingly..`
                },
                {
                    Text:`The isEmpty method checks whether the top has the length or the same number of elements as those pushed to the stack.`
                },
                {
                    Text:`The peek method accesses the top element using its index position.`
                },
                {
                    Text:`The length method returns the size by returning the top plus one.`
                },
                {
                    Text:`The print method displays all elements in the stack using a for loop that iterates over each element in the stack array.`
                },
                {
                    Title:"Code Example",
                    Sample:`class Stack {

    private data: number[];
    private top: number;
    private size: number;
    private readonly STACK_EMPTY = -1;

    constructor(size: number) {
        this.data = [];
        this.top = this.STACK_EMPTY;
        this.size = size
    }


    public push(item: number): void {

        if (this.isFull()) {
            console.log("could not push element");
            return;
        }else{
            this.top++;
            this.data[this.top] = item
        }
    }

    private isFull(): boolean {
        return this.top == this.size - 1;
    }

    public isEmpty(): boolean {
        return this.top == this.STACK_EMPTY;
    }

    public peek(): number {
        return this.data[this.top];
    }

    public pop(): number {
        if (this.isEmpty()) {
            return this.STACK_EMPTY;
        }

        let item: number = this.data[this.top];
        this.top--;
        return item;
    }

    public length(): number {
        return this.top + 1;
    }

    public print(): void {
        for (let index = 0; index <= this.top; index++) {
            console.log(this.data[index]);
        }
    }

}

const stack = new Stack(3);

stack.push(1);

console.log("empty: ",stack.isEmpty());

stack.push(2);
stack.push(3);

stack.pop() // delete 3

stack.push(4);

console.log("len: ",stack.length());

console.log("print");

stack.print();
// 4
console.log("top: ",stack.peek());`
                },
                {
                    Title:"Conclusion",
                    Text:`Stacks are simple yet powerful data structures that operate on a Last In, First Out (LIFO) principle.
                     With core operations like push, pop, peek, and isEmpty, they are ideal for tasks like undo functionality,
                    expression evaluation, and backtracking.
                    Whether implemented with arrays or linked lists, stacks are essential for solving many real-world problems efficiently.`
                }
            ]
        }
    ]
}